export default "__VITE_ASSET__BIuxy6TY__"